//import React from "react";
import React, { useState, useContext} from 'react';
import { useTranslation } from 'react-i18next';

// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Search from "@material-ui/icons/Search";
import Edit from "@material-ui/icons/Edit";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import { SessionContext } from "beaktShared/services/session";

import { useGetApi, UsePostApi, UsePutApi } from "beaktShared/services/crudeApiService";
import { GerenciaModal } from "beaktShared/views/Crud/ModalDetail";
import DebitoFixoForm from "./DebitoFixoForm";
import { transformValueFloattoFormated } from "beaktShared/helpers/masks";

import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
const useStyles = makeStyles(styles);

export default function DebitoFixoList() {
    const { t } = useTranslation();

    const session = useContext(SessionContext);

    const endPoint = 'debitofixos/';  
   
    const [showFormView, setshowFormView] = React.useState(false);
    const [item, setItem] = useState({});          
    const [loadingForm, setLoadingForm] = React.useState(false);

    const getEndPoint = () => {
        let endPointGet = "";
        if(session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
            endPointGet =  endPoint +"byfranquia/"+ session.franquiaId;
        return  endPointGet;
    }
    const [{list, isLoadingList, isErrorGetList}, setListAtualiza] = useGetApi(getEndPoint());
    
    const [notification, setNotification] = React.useState(false);
    const [colorNotification, setColorNotification] = React.useState('info');    
    const [mensagemNotification, setMensagemNotification] = React.useState(false);
    const showNotification = (mensagem,color) => { 
        setMensagemNotification(mensagem);
        setColorNotification(color);      
        setNotification(true);
        setTimeout(function() {
            setNotification(false);
        }, 6000);       
    };
  
    const handleAdd = item => {
        
        var newitem = "";
        if(session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
        {
            newitem = {
                ...item,
                franquiaId:session.franquiaId
            };
        }
        
        var vefifyExists = list.filter(obj => {
            return obj.debitoFixoId === item.debitoFixoId;
        });

        if(vefifyExists.length > 0)
        {
            setLoadingForm(true);
            UsePutApi(endPoint,item.debitoFixoId,newitem).then(result=>{
                setLoadingForm(false);
                if(result.status !== 200)
                {                                    
                    showNotification(result.message,'danger');
                    return false; 
                } 
                    
                const updateList = list.map(l => (l.debitoFixoId === item.debitoFixoId ? item : l));
                setListAtualiza(updateList);
                handleView(true);
                showNotification(result.message,'success');
                return true;                 
            });             
        }
        else
        {    
            setLoadingForm(true);
            UsePostApi(endPoint,newitem).then(result=>{                
                setLoadingForm(false);  
                if(result.status !== 200)
                {                                     
                    showNotification(result.message,'danger');
                    return false; 
                } 
                
                const addItemList = [...list, result.data];
                setListAtualiza(addItemList); 
                handleView(true);
                showNotification(t('information_message.registered_successfully'),'success');
                return true;                
            });         
        }

        return false;        
    };   

    const handleView = (resetItem) => {    
        if(resetItem)
            setItem({});
        let show = showFormView === true ? false : true;
        setshowFormView(show);             
    };

    const [detailModal, setConfModal] = GerenciaModal();
    const handleDetail = row => {  
        
        let valor = transformValueFloattoFormated(row.valor);
        const bodyDetail=(
        <div>
            <p><b>{t('label.historic')}:</b> {row.historico}</p>            
            <p><b>{t('label.value')}:</b> {valor}</p>
            <p><b>{t('label.status')}:</b> {row.ativo === true ? t('label.active') : t('label.inactive')}</p>
        </div>);

        setConfModal({
            showmodal: true,
            dataShow: bodyDetail
          });
    };

    const handleEdit = row => {       
        setItem(row);
        handleView(false);
    };

    const columnsProp = [{
        Header: t('label.historic'),
        accessor: "historico",
    },
    {
        Header: t('label.value'),
        accessor: "valor",
        Cell: (props) => <div> {transformValueFloattoFormated(props.value)} </div>  
    },    
    {
        Header: t('label.status'),
        accessor: "ativo",
        Cell: (props)=> <span>  {props.value === true ?  t('label.active') : t('label.inactive')} </span>
    }
    ]
    const columnsAcao = [        
        {
            Header: t('label.actions'),
            Cell: row => (
                <div className="actions-right">                        
                <Button
                    justIcon
                    round
                    simple                            
                    color="info"
                    className="info"
                    onClick={() => handleDetail(row.original)}
                >
                <Tooltip title={t('label.detail')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                <Search />
                </Tooltip>
                </Button>{" "}
                <Button
                    justIcon
                    round
                    simple
                    color="success"
                    className="edit"
                    onClick={() => handleEdit(row.original)}
                >
                <Tooltip title={t('label.to_edit')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                <Edit />
                </Tooltip>
                </Button>{" "}
            </div>
            ),
            sortable: false,
            filterable: false
        }
    ];
    const columns = [...columnsProp,...columnsAcao]

    const classes = useStyles();
    return (
        <div>

            <Snackbar
                place="tr"
                color={colorNotification}
                message={mensagemNotification}
                open={notification}
                closeNotification={() => setNotification(false)}
                close
            />

            {showFormView && 
                <DebitoFixoForm addItem={handleAdd} item={item} handleView={handleView} loading={loadingForm} />} 
            
            {!showFormView &&
                <GridContainer>            
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>{t('royaltie.list_of_fixed_debits')}</h4>
                        </CardHeader>
                        <CardBody>
                            <Button
                                color="primary"
                                className={classes.newButton}
                                onClick={() => handleView(true)}
                            >
                               {t('button.new')}
                            </Button>                           

                            {isErrorGetList && <div>{t('error_message.loading_error')}...</div>}
                            <ReactTable
                                loading = {isLoadingList}
                                data={list}
                                filterable
                                columns={columns}
                                defaultPageSize={10}
                                minRows={5}
                                showPaginationBottom={true}
                                className="-striped -highlight"
                                previousText={t('button.previous')}
                                nextText={t('button.next')}
                                loadingText={t('label.loading')+"..."}
                                noDataText={t('information_message.no_records_found')+"!"}
                                pageText={t('label.page')}
                                ofText={t('label.of')}
                                rowsText={t('label.rows')}
                            />
                        </CardBody>
                    </Card>
                </GridItem>            
            </GridContainer>
            }
            
            {detailModal}            
        </div>
    );
}
